<template>
    <div class="elle-toggle-list">
        <div v-for="item in items" :key="item.id" class="item" @click="e => onToggle(e)">
            <div class="item-headline h4">
                <span class="text">{{ item.title }}</span>
            </div>
            <div class="item-content">
                <div class="content typography" v-html="item.body" />
                <div v-if="item?.linksUrls.length || item?.files.length" class="buttons-wrapper">
                    <div v-if="item?.linksUrls.length" class="buttons">
                        <UiLink v-for="(link, index) in item?.linksUrls" :key="index" :link="link" :style="'elle-btn transparent w-border'" />
                    </div>

                    <div v-if="item?.files.length" class="buttons">
                        <NuxtLink
                            v-for="file in item.files"
                            :key="file.id"
                            :external="true"
                            :target="'_blank'"
                            :title="file.title"
                            :to="file.url"
                            class="elle-btn transparent w-border"
                        >
                            <span class="text">{{ file.title }}</span>
                            <span class="icon square">
                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 12V19M12 19L9.75 16.6667M12 19L14.25 16.6667M6.6 17.8333C4.61178 17.8333 3 16.1917 3 14.1667C3 12.498 4.09438 11.0897 5.59198 10.6457C5.65562 10.6268 5.7 10.5675 5.7 10.5C5.7 7.46243 8.11766 5 11.1 5C14.0823 5 16.5 7.46243 16.5 10.5C16.5 10.5582 16.5536 10.6014 16.6094 10.5887C16.8638 10.5306 17.1284 10.5 17.4 10.5C19.3882 10.5 21 12.1416 21 14.1667C21 16.1917 19.3882 17.8333 17.4 17.8333"
                                        stroke="#000000"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </span>
                        </NuxtLink>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const props = withDefaults(
    defineProps<{
        items?: CmsItem[];
    }>(),
    {
        items: () => []
    }
);

const items = computed(() => props.items);

const { $gsap: gsap, $ScrollTrigger: ScrollTrigger } = useNuxtApp();
const onToggle = (e: MouseEvent) => {
    if (!e?.target) return;

    const target = e.target as HTMLElement;

    if (target.closest('a')) return;

    const parentItem = target.closest('.item') as HTMLElement;
    const itemContent = parentItem?.querySelector('.item-content') as HTMLElement;

    if (parentItem?.classList.contains('active')) {
        gsap.to(itemContent, {
            height: 0,
            marginTop: '0',
            ease: 'sine.out',
            onStart: () => {
                parentItem.classList.remove('active');
            },
            onComplete: () => {
                ScrollTrigger.refresh(true);
            }
        });
    } else {
        gsap.to(itemContent, {
            height: 'auto',
            marginTop: '1.25rem',
            ease: 'sine.in',
            onStart: () => {
                parentItem.classList.add('active');
            },
            onComplete: () => {
                ScrollTrigger.refresh(true);
            }
        });
    }
};
</script>
